/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ConsultationContentDto } from '../../models/consultation-content-dto';

export interface ConsultationContentAdminControllerFindByIdV1$Params {
  id: string;
}

export function consultationContentAdminControllerFindByIdV1(http: HttpClient, rootUrl: string, params: ConsultationContentAdminControllerFindByIdV1$Params, context?: HttpContext): Observable<StrictHttpResponse<ConsultationContentDto>> {
  const rb = new RequestBuilder(rootUrl, consultationContentAdminControllerFindByIdV1.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ConsultationContentDto>;
    })
  );
}

consultationContentAdminControllerFindByIdV1.PATH = '/api/v1/consultation-contents/admin/{id}';
